import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modal: {
    opened: false,
  },
  refreshModal: {
    opened: false,
  },
  toRefresh: false,
  betaModal: {
    opened: false,
  },
  pageType: null as string | null,
  contentId: null as string | null
};

export const assistant = createSlice({
  name: 'assistant',
  initialState,
  reducers: {
    startAssistantConversation: (state) => {
      state.modal.opened = true;
    },

    endAssistantConversation: (state) => {
      state.modal.opened = false;
    },

    openRefreshModal: (state) => {
      state.refreshModal.opened = true;
    },

    closeRefreshModal: (state) => {
      state.refreshModal.opened = false;
    },

    setToRefresh: (state) => {
      state.toRefresh = !state.toRefresh;
    },

    openBetaModal: (state) => {
      state.betaModal.opened = true;
    },

    closeBetaModal: (state) => {
      state.betaModal.opened = false;
    },

    setPageType: (state, action) => {
      state.pageType = action.payload.type;
      state.contentId = action.payload.id;
    },
  }
});

export const {
  startAssistantConversation, endAssistantConversation, openRefreshModal, closeRefreshModal,
  setToRefresh, openBetaModal, closeBetaModal, setPageType,
} = assistant.actions;

export default assistant.reducer;
